import { GET_ALL_ORDERS } from "../constants/endpoints";
import axiosClient from "./axios";

class orderService {
  static async fetchAllOrders(
    currentPage: number,
    itemsPerPage: number,
    state: string,
    externalOrderId: string,
    bapId: string,
    shopName: string,
    deliveryPincode: string,
    paymentTransactionId: string,
    shopType: string,
    startDate: string,
    endDate: string,
    isSettled: boolean,
    isOndcFaSettled: boolean,
    deliveryStatus: string,
    paymentType: string,
    paymentMode: string,
    customerName: string,
    customerPhone: string,
    deliveryUserId: string,
    isHeavyItemPresent: boolean,
    isDeliveryLocationUpdated: boolean,
    itemId: string,
    rating: string,
    created_at: string,
    modified_at: string,
    shopId: string,
    searchTerm: string
  ) {
    const filters = {
      state: state !== null ? state : undefined,
      deliveryStatus: deliveryStatus !== null ? deliveryStatus : undefined,
      externalOrderId: externalOrderId !== null ? externalOrderId : undefined,
      bapId: bapId !== null ? bapId : undefined,
      shopName: shopName !== null ? shopName : undefined,
      deliveryPincode: deliveryPincode !== null ? deliveryPincode : undefined,
      paymentTransactionId:
        paymentTransactionId !== null ? paymentTransactionId : undefined,
      shopType: shopType !== null ? shopType : undefined,
      startDate: startDate !== null ? startDate : undefined,
      endDate: endDate !== null ? endDate : undefined,
      isSettled: isSettled !== null ? isSettled : undefined,
      isOndcFaSettled: isOndcFaSettled !== null ? isOndcFaSettled : undefined,
      paymentType: paymentType !== null ? paymentType : undefined,
      paymentMode: paymentMode !== null ? paymentMode : undefined,
      customerName: customerName !== null ? customerName : undefined,
      customerPhone: customerPhone !== null ? customerPhone : undefined,
      deliveryUserId: deliveryUserId !== null ? deliveryUserId : undefined,
      isHeavyItemPresent:
        isHeavyItemPresent !== null ? isHeavyItemPresent : undefined,
      isDeliveryLocationUpdated:
        isDeliveryLocationUpdated !== null
          ? isDeliveryLocationUpdated
          : undefined,
      itemId: itemId !== null ? itemId : undefined,
      rating: rating !== null ? rating : undefined,
      shopId: shopId !== null ? shopId : undefined,
      searchTerm: searchTerm !== null ? searchTerm : undefined,
    };
    const sort = {
      created_at: created_at !== null ? created_at : undefined,
      modified_at: modified_at !== null ? modified_at : undefined,
    };
    const response = await axiosClient.post(GET_ALL_ORDERS, {
      page: currentPage,
      limit: itemsPerPage,
      filters: filters,
      sort: sort,
    });
    return response;
  }
}

export default orderService;
